<template>
  <AiEducationLayout>
    <EducationPageHeader
      :title="course?.name || '课程详情'"
      description="仅展示当前学生有权限访问的课程内容"
    />
    <ContentWrap>
      <EducationState v-if="state === 'loading'" state="loading" title="正在加载课程详情" />
      <EducationState
        v-else-if="state === 'error'"
        state="error"
        title="课程详情加载失败"
        @retry="load"
      />
      <template v-else-if="course">
        <p class="description">{{ course.description || course.subtitle || '暂无课程简介' }}</p>
        <el-divider />
        <EducationState
          v-if="!course.chapters?.length"
          state="empty"
          title="暂无章节内容"
          description="课程章节发布后会显示在这里。"
        />
        <el-timeline v-else>
          <el-timeline-item v-for="chapter in course.chapters" :key="chapter.id">
            <div class="chapter-row">
              <span>{{ chapter.name || chapter.title || '未命名章节' }}</span>
              <el-tag v-if="chapter.isFinished" type="success" size="small">已完成</el-tag>
              <el-tag v-else-if="chapter.accessible === false" type="info" size="small">{{
                chapter.lockReason || '暂不可用'
              }}</el-tag>
              <el-tag v-else type="warning" size="small">{{ chapter.progress || 0 }}%</el-tag>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'
import { merchantApi } from '@/config/axios'
import type { StudentCourseVO } from '@/api/aiEducation'

defineOptions({ name: 'AiEducationStudentCourseDetail' })
const route = useRoute()
const course = ref<StudentCourseVO | null>(null)
const state = ref<'loading' | 'ready' | 'error'>('loading')
const load = async () => {
  try {
    course.value = await merchantApi.get<StudentCourseVO>({
      url: '/app-api/train/course/get',
      params: { id: route.params.id }
    })
    state.value = 'ready'
  } catch {
    state.value = 'error'
  }
}
onMounted(load)
</script>

<style scoped>
.description {
  color: #697681;
  line-height: 1.7;
}
.chapter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
</style>
